import React, { Fragment } from 'react';
import {
  Image,
  Text,
  FurtherLink,
  EmbeddedVideo,
  EmbeddedPost,
  Video,
  Quote,
} from './DisplayComponents';
import { types } from '../config';

const ContentList = ({
  content: blockContent,
  id,
}) => {
  const Content = blockContent.map((elem, index) => {
    if (!elem) {
      return null;
    }
    const { type, content, url, caption, who } = elem;
    if (type === types.text) {
      return (
        <Text
          key={`${id}_${index}`}
          content={content}
        />
      );
    }
    if (type === types.furtherLink) {
      return (
        <FurtherLink
          key={`${id}_${index}`}
          content={content}
          url={url}
        />
      );
    }
    if (type === types.image) {
      return (
        <Image
          key={`${id}_${index}`}
          url={url}
          caption={caption}
        />
      );
    }
    if (type === types.embeddedVideo) {
      return (
        <EmbeddedVideo
          key={`${id}_${index}`}
          content={content}
        />
      );
    }
    if (type === types.embeddedPost) {
      return (
        <EmbeddedPost
          key={`${id}_${index}`}
          content={content}
        />
      );
    }
    if (type === types.video) {
      return (
        <Video
          key={`${id}_${index}`}
          url={url}
          caption={caption}
        />
      );
    }
    if (type === types.quote) {
      return (
        <Quote
          key={`${id}_${index}`}
          content={content}
          url={url}
          who={who}
        />
      );
    }
    return null;
  })
  return (
    <Fragment>
      {Content}
    </Fragment>
  )
}

export default ContentList;
